import { getApiBase } from "../api/healthThreatsApi";

const API_BASE_URL = getApiBase().replace(/\/+$/, "");

export const TB_COUNTRIES = Object.freeze({
  SE: { country: "SWEDEN", label: "Sweden", localScope: "STOCKHOLM", localLabel: "Stockholm" },
  BE: { country: "BELGIUM", label: "Belgium", localScope: "BRUSSELS", localLabel: "Brussels" },
  GR: { country: "GREECE", label: "Greece", localScope: "THESSALONIKI", localLabel: "Thessaloniki" },
  IE: { country: "IRELAND", label: "Ireland", localScope: "DUBKILD", localLabel: "Dublin and Kildare" },
  IT: { country: "ITALY", label: "Italy", localScope: "TORINO", localLabel: "Torino" },
});

function configFor(countryIso) {
  const config = TB_COUNTRIES[countryIso];
  if (!config) throw new Error(`Unsupported TB outbreak country: ${countryIso}`);
  return config;
}

export function tbOutputFileUrl(filename) {
  return `${API_BASE_URL}/visualizations/file/${encodeURIComponent(filename)}`;
}

async function requestJson(url, options = {}) {
  const response = await fetch(url, { cache: "no-store", ...options });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const detail = payload?.detail;
    throw new Error(typeof detail === "string" ? detail : `TB request failed (${response.status})`);
  }
  return response.json();
}

export function loadTBMetrics(countryIso = "SE") {
  return requestJson(tbOutputFileUrl(`${configFor(countryIso).country}_Screening_Metrics_TB_EP.json`));
}

export function loadTBFigure(filename) {
  return requestJson(tbOutputFileUrl(filename));
}

export function getTBMapUrl(countryIso = "SE") {
  return tbOutputFileUrl(`${configFor(countryIso).country}_Screening_HeatMap_TB_Folium.html`);
}

export function checkTBNewResponses(countryIso = "SE") {
  configFor(countryIso);
  return requestJson(`${API_BASE_URL}/tb/outbreak/check-new-responses?country_iso=${countryIso}`);
}

export function refreshTBOutbreakOutputs(countryIso = "SE") {
  configFor(countryIso);
  return requestJson(`${API_BASE_URL}/tb/outbreak/refresh-outputs?country_iso=${countryIso}`, { method: "POST" });
}

export async function loadTBOutbreakAlerts() {
  const results = await Promise.allSettled(
    Object.keys(TB_COUNTRIES).map(async (countryIso) => ({ countryIso, metrics: await loadTBMetrics(countryIso) }))
  );
  return results.flatMap((result) => result.status === "fulfilled" ? [result.value] : []);
}
